import classNames from 'classnames';
import { useCallback } from 'react';
import FlexContainer from '../FlexContainer';
import DatePicker from 'react-datepicker';
import { CustomInput } from './components';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePicker.scss'; // Custom styles
import styles from './DateInput.module.scss';

/**
 * DateInput
 *
 * @return {JSX.Element}
 */
const DateInput = ({
  className,
  value,
  name,
  onChange,
  customLabel,
  reverse,
  asInput,
  showYearDropdown,
  // required,
  ...rest
}) => {
  const handleChange = useCallback(
    (newDate) => {
      onChange?.({ target: { name, value: newDate } });
    },
    [onChange, name]
  );

  return (
    <FlexContainer
      className={classNames(styles.DateInput, className, DateInput.displayName)}
    >
      <DatePicker
        name={name}
        selected={value}
        onChange={handleChange}
        showYearDropdown={showYearDropdown}
        customInput={
          <CustomInput
            label={customLabel}
            reverse={reverse}
            asInput={asInput}
            // inputName={name}
            // inputRequired={required}
          />
        }
        {...rest}
      />
    </FlexContainer>
  );
};

DateInput.displayName = 'DateInput';

export default DateInput;
